const units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];

export function bytes(value, precision?) {
    if (isNaN(parseFloat(value)) || !isFinite(value)) {
        return '-';
    }
    if (!precision && precision !== 0) {
        precision = 1;
    }
    const i = Math.floor(Math.log(value) / Math.log(1024));
    return (value / Math.pow(1024, i)).toFixed(precision) +  ' ' + units[i];
}
